import { antiNameHandler } from 'module/anti_name_handler';
import React, { useEffect } from 'react';
import strings from '../../strings/strings.json'

interface Props {
  data: any
  compressed: any
}
export default function AvsResultStatus(props: Props) {
  useEffect(() => {
  }, [props.data, props.compressed])

  const mapHandler = (data: any, index: number) => {
    for (const malware of props.data[data]) {
      return (
        <div key={index} className='fade_in border-b border-gray-200 py-2'>
          <div className='flex mb-2 items-center'>
            <img className='w-6 h-6 ml-1' src={require(`../../assets/icons/${malware.av_name}.png`)} alt="Icon" />
            <span className='VazirEng'>{antiNameHandler(malware.av_name)}</span>
          </div>
          <div dir='rtl' className='VazirEng secondry_text_color text-xs w-52 truncate mt-1'><span className='whitespace-nowrap' dir="ltr" title={data}>{data}</span></div>
          <div className='font-medium text-red-500 VazirEng block w-52 truncate'>{malware.malware_name}</div>
        </div>
      )
    }
  }

  const compressedMapHandler = (data: any, index: number) => {
    return (
      <div key={index}>
        {
          Object.values(data).map((dta: any, inx: number) => {
            return (
              <div key={inx} className='fade_in border-b border-gray-200 py-2'>
                <div className='flex mb-2 items-center'>
                  <img className='w-6 h-6 ml-1' src={require(`../../assets/icons/${dta[0].av_name}.png`)} alt="Icon" />
                  <span className='VazirEng'>{antiNameHandler(dta[0].av_name)}</span>
                </div>
                <div className='w-52 flex flex-col VazirEng'>
                  <div className='truncate'><span>{'<=='}</span> <span dir='ltr' title={Object.keys(props.compressed)[index]}>{Object.keys(props.compressed)[index]}</span></div>
                  <div className='truncate secondry_text_color text-xs'><span dir='ltr' title={`${Object.keys(data)[inx]}`}>{Object.keys(data)[inx]}</span></div>
                </div>
                <div className='font-medium text-red-500 VazirEng block w-52 truncate'>{dta[0].malware_name}</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  return (
    <div className={`flex flex-col px-4 py-4 h-full ${(props.data !== undefined || props.compressed !== undefined) ? 'overflow-y-scroll' : ''}`}>
      <div className='flex flex-wrap sm:hidden'>
        <span className='primary_text_color font-bold text-lg'>{strings.public_status}: </span>
        <span
          className={`rounded-2xl px-2 py-1 text-white text-xs mr-1 ${((props.data !== undefined && props.compressed !== undefined) && Object.keys(props.data).length !== 0) ?
            'bg-red-500'
            :
            'bg-green-500'}`}
        >
          {(props.data !== undefined && Object.keys(props.data).length !== 0 || props.compressed !== undefined && Object.keys(props.compressed).length !== 0) ?
            strings.public_malwareFound
            :
            strings.public_notFoundMalwareYet}
        </span>
      </div>
      <div className='flex flex-col'>
        {
          (props.data !== undefined && props.data) && Object.keys(props.data).map(mapHandler)
        }
        {
          (props.compressed !== undefined && Object.values(props.compressed).length !== 0) &&
          (Object.values(props.compressed)).map(compressedMapHandler)
        }
      </div>
    </div>
  )
}
